// extracted by mini-css-extract-plugin
export default {"Events":"Details_Events__JSV9L","header":"Details_header__UYUu6"};